import React, { useContext } from 'react';
import Grid2 from '@mui/material/Grid2';
import { Controller, useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';


import { AppContext } from 'context/AppContextProvider';
import { useCreateOpenDoorEventAsync } from '../../../services/Events/OpenDoorEventService/hooks/useMutation';
import TextFieldComponent from '../../../components/TextFieldComponent';
import ModalComponent from '../../../components/ModalComponent';

interface Props {
  open: boolean;
  deviceId: number | null;
  onClose: () => void;
}

type FormValues = {
  name: string;
  cpf: string;
  description: string;
};

const RegisterOpenDoorModal = ({ open, deviceId, onClose }: Props) => {
  const { showSnackbar } = useContext(AppContext);

  const { mutateAsync: createEvent, isLoading } =
    useCreateOpenDoorEventAsync();

  const { control, handleSubmit, reset } = useForm<FormValues>({
    defaultValues: {
      name: '',
      cpf: '',
      description: '',
    },
  });

  const onSubmit = async (data: FormValues) => {
    if (!deviceId) return;

    try {
      await createEvent({
        deviceId,
        type: 'OPEN_DOOR',
        name: data.name,
        cpf: data.cpf,
        description: data.description,
      });

      showSnackbar('Abertura registrada com sucesso.', 'success');
      reset();
      onClose();
    } catch (e: any) {
      showSnackbar(e?.message ?? 'Erro ao registrar abertura.', 'error');
    }
  };

  return (
    <ModalComponent
      isOpen={open}
      onClose={onClose}
      title="Registrar abertura de porta"
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12 }}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextFieldComponent
                label="Nome"
                value={field.value}
                onChangeText={field.onChange}
              />
            )}
          />
        </Grid2>

        <Grid2 size={{ xs: 12 }}>
          <Controller
            name="cpf"
            control={control}
            render={({ field }) => (
              <TextFieldComponent
                label="CPF"
                value={field.value}
                onChangeText={field.onChange}
              />
            )}
          />
        </Grid2>

        <Grid2 size={{ xs: 12 }}>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextFieldComponent
                label="Descrição"
                multiline
                value={field.value}
                onChangeText={field.onChange}
              />
            )}
          />
        </Grid2>

        <Grid2 size={{ xs: 12 }}>
          <LoadingButton
            fullWidth
            variant="contained"
            loading={isLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Salvar registro
          </LoadingButton>
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default RegisterOpenDoorModal;
